<template>
  <div class="relative items-center py-3">
    <label v-if="labelText" class="whitespace-nowrap text-sm font-medium not-italic text-gray-800">{{
      labelText
    }}</label>
    <div class="flex w-full justify-center">
      <small-loader v-if="isLoading" height="h-8" width="w-8" />
      <v-select
        v-else
        :label="label"
        :options="options"
        :reduce="(value : any) => value[reduceKey]"
        :value="modelValue"
        class="w-full"
        @input="$emit('update:modelValue', $event[reduceKey])"
        @option:selecting="$emit('update:modelValue', $event[reduceKey])"
      ></v-select>
      <span v-if="isError" class="error-message text-sm text-error">{{ errorMessage }}</span>
      <span v-if="isSuccess" class="rounded-sm bg-success p-2 text-sm text-white">{{ successMessage }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import VSelect from "vue-select";
import SmallLoader from "@/core/Components/SmallLoader.vue";

export default defineComponent({
  components: {
    VSelect,
    SmallLoader,
  },
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    isLoading: Boolean,
    options: {
      type: Array as PropType<any[]>,
      required: true,
    },
    reduceKey: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    labelText: {
      type: String,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    successMessage: {
      type: String,
      default: "",
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isSuccess: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
});
</script>

<style scoped></style>
